function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.98101 7.34405C8.91838 4.10748 12.433 2.42711 15.3033 1.58142C16.7366 1.15911 17.9892 0.951252 18.8937 0.860939C19.347 0.815673 19.6986 0.801369 19.9297 0.801838L19.9639 0.802021C20.1208 0.891773 20.2619 1.00775 20.3808 1.14541C20.548 1.33914 20.6663 1.57017 20.7258 1.8191C20.7852 2.06766 20.7842 2.32681 20.7229 2.57488C20.5734 3.17342 20.5 3.69395 20.5 4.19994C20.5 7.9433 23.5403 10.9898 27.2814 10.9999L27.3045 11L27.3275 10.9995C27.9046 10.9878 28.4779 10.9017 29.0331 10.7435L29.038 10.7421C29.2752 10.6811 29.524 10.6756 29.7648 10.7264C30.0096 10.778 30.2389 10.8865 30.434 11.0431C30.6292 11.1996 30.7848 11.3999 30.8883 11.6277C30.9918 11.8555 31.0403 12.1044 31.0298 12.3544L31.0297 12.3573C31.0297 12.3573 31.0297 12.3588 31.0294 12.3635L31.0281 12.3824C31.027 12.3987 31.0253 12.4189 31.0232 12.4424C31.0189 12.4898 31.0134 12.541 31.0082 12.5861L30.9922 12.7233L30.9952 12.8614C31.0735 16.4191 34.0879 19.3909 37.7832 19.3999L37.8041 19.4L37.8249 19.3996C38.3904 19.3892 38.9522 19.3069 39.497 19.1547L39.5037 19.1528C39.7315 19.0977 39.9697 19.093 40.2015 19.1397C40.4382 19.1874 40.6611 19.2876 40.8539 19.4329C41.0453 19.5792 41.2015 19.7666 41.3108 19.9814C41.418 20.1919 41.4775 20.4235 41.485 20.6596L41.486 20.691L41.488 20.7224C41.4956 20.8411 41.5 20.923 41.5 21C41.5 32.3032 32.3033 41.5 21 41.5C9.69763 41.5 0.501395 32.3047 0.499955 21.0026L0.499926 20.9951C0.481656 16.327 2.76724 10.8852 5.98101 7.34405ZM17.518 6.27078L17.0341 3.99636L14.8577 4.81497C11.8861 5.93263 9.26871 7.85533 7.30873 10.3844C4.95495 13.4217 3.68465 17.1594 3.69999 21.002L3.7 21.0039C3.70212 30.5413 11.4621 38.3 21 38.3C29.2022 38.3 36.0837 32.5652 37.857 24.8977L38.3395 22.8116L36.2253 22.4723C34.4706 22.1907 32.813 21.4454 31.43 20.3018C29.9284 19.06 28.8273 17.4121 28.2515 15.5654L27.8495 14.2762L26.5035 14.1673C24.2289 13.9833 22.076 13.0261 20.4109 11.4423C18.9382 10.0415 17.9359 8.23511 17.518 6.27078Z",
  fill: "white"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1387 0.808194C20.183 0.812057 20.1749 0.814008 20.1312 0.807594L20.1387 0.808194Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 16.75C15.5 17.7165 14.7165 18.5 13.75 18.5C12.7835 18.5 12 17.7165 12 16.75C12 15.7835 12.7835 15 13.75 15C14.7165 15 15.5 15.7835 15.5 16.75Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.5 28.75C18.5 29.7165 17.7165 30.5 16.75 30.5C15.7835 30.5 15 29.7165 15 28.75C15 27.7835 15.7835 27 16.75 27C17.7165 27 18.5 27.7835 18.5 28.75Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.5 25.75C27.5 26.7165 26.7165 27.5 25.75 27.5C24.7835 27.5 24 26.7165 24 25.75C24 24.7835 24.7835 24 25.75 24C26.7165 24 27.5 24.7835 27.5 25.75Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.5 1.75C30.5 2.7165 29.7165 3.5 28.75 3.5C27.7835 3.5 27 2.7165 27 1.75C27 0.783502 27.7835 0 28.75 0C29.7165 0 30.5 0.783502 30.5 1.75Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/cookie.dc2aa87b.svg";
export { SvgComponent as ReactComponent };